(() => {
  window.swinger.eventHub.register('click', '.swinger-button', (e) => {
    const elem = window.swinger.eventHub.getTarget(e).closest('.swinger-button');

    window.swinger.eventHub.trigger(document, 'swinger.button:click', {
      elem,
    });

    if (elem.hasAttribute('data-href')) {
      const url = elem.getAttribute('data-href');

      window.swinger
        .ajax(url, {
          method: 'POST',
        })
        .then(() => {
          window.swinger.i18n()
            .then((i18n) => {
              window.swinger.snackbar.create({
                isSelfclosing: true,
                children: [
                  {
                    component: 'notification',
                    data: {
                      type: 'success',
                      text: i18n('ui.shared.message.success'), // Can't be more precise as we don't know what's being triggered
                    },
                  },
                ],
              });
            })
            .catch(console.info);
        })
        .catch(() => {
          window.swinger.i18n()
            .then((i18n) => {
              window.swinger.snackbar.create({
                isSelfclosing: true,
                children: [
                  {
                    component: 'notification',
                    data: {
                      type: 'error',
                      text: i18n('ui.shared.message.error'), // Can't be more precise as we don't know what's being triggered
                    },
                  },
                ],
              });
            })
            .catch(console.info);
        });
    }
  });

  window.swinger.eventHub.register('keyup', '.swinger-button[for][tabindex="-1"]', (e) => {
    if (e.key !== ' ' && e.key !== 'Enter') {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e).closest('.swinger-button');
    const id = elem.getAttribute('for');
    const input = document.getElementById(id);

    if (input) {
      input.focus();
    }
  });
})();
